import { Sidebar } from "../../Components/Sidebar/Sidebar";
import { useMainContext } from "../../Contexts/MainContext";
import { ProductsCard } from "../../Components/Cards/ProductsCard";
import "./ProductsPage.style.css";
import { MyLoader } from "../../Components/Loader/Loader";
import { useScrollToTop } from "../../Hooks/useScrollToTop";
import { useProducts } from "../../Contexts/ProductContext";
import { usePageTitle } from "../../Hooks/usePageTitle";

export const ProductsPage = () => {
  const { sortBy, showProducts, showDeluxe } = useMainContext();
  const { products, loader } = useProducts();
  usePageTitle("AstroMart || Products");
  useScrollToTop();

  function getSorted(products, sortBy) {
    if (sortBy && sortBy === "PRICE_LOW_TO_HIGH") {
      return products.sort((a, b) => a["price"] - b["price"]);
    }
    if (sortBy && sortBy === "PRICE_HIGH_TO_LOW") {
      return products.sort((a, b) => b["price"] - a["price"]);
    }
    return products;
  }

  function getFiltered(products, { showProducts, showDeluxe }) {
    return products
      .filter(({ stock }) => (showProducts ? true : stock))
      .filter(({ deluxe }) => (showDeluxe ? deluxe : true));
  }

  const sorted = getSorted(products, sortBy);
  const filtered = getFiltered(sorted, { showProducts, showDeluxe });

  return (
    <>
      <h2 className="wishlist-cart-heading"> Our Products </h2>
    <div className="product-page">
      <Sidebar />
      <div className="products-container">
        {loader && <MyLoader />}
        {filtered.map((item) => (
          <ProductsCard key={item._id} product={item} />
        ))}
      </div>
    </div>
    </>
  );
};
